import React from 'react'
import { Folder } from '../icons'

const SideBarTab = ({ active, text }) => {
  const iconColor = active ? '#4a90e2' : '#C5C5C9'
  const textColor = active ? '#4a90e2' : '#707070'

  return (
    <div className="side-bar-tab">
      <div className="icon">
        <Folder color={iconColor} />
      </div>
      <span className="text" style={{ color: textColor }}>
        {text}
      </span>
      <style jsx>{`
        .side-bar-tab {
          cursor: pointer;
          display: flex;
          align-items: center;
        }
        .icon {
          width: 16px;
        }
        .text {
          display: inline-block;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-left: 8px;
          overflow: hidden;
        }
      `}</style>
    </div>
  )
}

export default SideBarTab



// WEBPACK FOOTER //
// ./src/components/sideBarTab/index.js